// @flow
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

type State = Object;
import {FETCH_FFC_DATA, SET_ERROR_TYPE, FETCH_COMPANION_FFC_DATA, FETCH_VIDEO_DATA} from '../types/CCDTypes';
import AppsUtil from '../utils/AppsUtil';
import {productData, errorTypes} from '../constants/ccdConstants';
import ContentParser from '@ccxi/ccxi-apps/src/utils/contentParser';
const initialState = {};

export default (state: State = initialState, action: Object) => {
	switch (action.type) {
		case FETCH_FFC_DATA:
		{
			const output = {};
			output.ffcData = action.payload.ffcData;
			if (!action.payload.ffcData) {
				output.errorType = errorTypes.serviceDown;
				return Object.assign({}, state, output);
			}
			const latestVersionData = {};
			const sapCode = action.payload.sapCode;
			const appData = action.payload.ffcData.data;
			AppsUtil.processAndStoreProductFFCData(appData, action.payload.sapCode);
			latestVersionData[sapCode] = AppsUtil.allVersionsFFCProductList[sapCode][AppsUtil.allVersionsFFCProductList[sapCode].length - 1];
			if (latestVersionData[sapCode]) {
				latestVersionData[sapCode].cvsDisplayName = productData[action.payload.productId].name;
			}
			AppsUtil.init(latestVersionData, null, null, null, null);
			return Object.assign({}, state, output);
		}
		case FETCH_VIDEO_DATA:
		{
			const output = {};
			const videoData = action.payload.videoContentfulData ? action.payload.videoContentfulData : action.payload.videoFallbackData;
			if (!videoData) {
				output.errorType = errorTypes.videoPanelDataUnavailable;
			}
			const parsedData = videoData && ContentParser.parse(videoData.data);
			const {items} = parsedData || {};
			output.videoData = items && items[0];
			return Object.assign({}, state, output);
		}
		case FETCH_COMPANION_FFC_DATA:
		{
			const output = {};
			if (!action.payload.ffcData) {
				output.errorType = errorTypes.companionAppDataUnavailable;
				return Object.assign({}, state, output);
			}
			const ccmChannel = action.payload.ffcData.data.channel.find(channel => channel.name === 'mobileApps');
			const productArr = ccmChannel ? ccmChannel.mobileApps.mobileApp : [];
			const filteredProductArr = productArr.filter(obj => obj.id === action.payload.sapCode);
			AppsUtil.companionMobileAppData = filteredProductArr[0];
			if (!AppsUtil.companionMobileAppData) {
				output.errorType = errorTypes.companionAppDataUnavailable;
				return Object.assign({}, state, output);
			}
			output.companionFFCData = AppsUtil.companionMobileAppData;
			return Object.assign({}, state, output);
		}
		case SET_ERROR_TYPE:
		{
			const output = {};
			output.errorType = action.payload.errorType;
			return Object.assign({}, state, output);
		}
		default:
			return state;
	}
};
